import { useParams } from "react-router";
import { AbstractCase } from "../types/Entities/AbstractCase";

const useProductParams = () => {
  const { productName, productId } = useParams();

  return {
    productName: productName as AbstractCase["name"],
    productId: productId ? parseInt(productId) : 0,
  };
}

export default useProductParams;
